module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "game-content-members"
    }
  }, [(!_vm.hasData) ? _c('loader-large') : _vm._e(), _vm._v(" "), (!_vm.editMembersMode) ? [(_vm.hasCurrentMembers) ? _c('h2', [_c('span', {
    staticClass: "label"
  }, [_vm._v("Active Members")]), _vm._v(" "), (_vm.isOwner) ? _c('span', {
    staticClass: "enter-edit-mode"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editMembersMode = true
      }
    }
  }, [_vm._v("Manage Members")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.organizedMembers.current), function(group, key) {
    return (group.members.length > 0) ? _c('div', {
      staticClass: "member-list"
    }, [_c('h3', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group.members), function(member) {
      return _c('router-link', {
        staticClass: "member-item",
        attrs: {
          "to": ("/Developer/" + (member.stringUrl))
        }
      }, [_c('div', {
        staticClass: "avatar-container"
      }, [_c('avatar', {
        attrs: {
          "profile-data": member,
          "profile-type": "developer",
          "size": "large",
          "show-xp-info": true
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "details"
      }, [_c('h3', [_vm._v(_vm._s(member.alias))]), _vm._v(" "), (member.modLevel === 'owner') ? _c('span', {
        staticClass: "mod-status"
      }, [_c('i', {
        staticClass: "fas fa-star"
      }), _vm._v(" Project Owner")]) : _vm._e(), _vm._v(" "), (member.modLevel === 'mod') ? _c('span', {
        staticClass: "mod-status"
      }, [_c('i', {
        staticClass: "fas fa-star"
      }), _vm._v(" Project Moderator")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(member.positionTitle))]), _vm._v(" "), _c('span', {
        staticClass: "time"
      }, [_vm._v("Joined " + _vm._s(_vm._f("formatDateWithoutTime")(member.joinDate)))])])])
    })], 2) : _vm._e()
  }), _vm._v(" "), (_vm.hasFormerMembers) ? [_c('h2', [_vm._v("Former Members")]), _vm._v(" "), _vm._l((_vm.organizedMembers.former), function(group, key) {
    return (group.members.length > 0) ? _c('div', {
      staticClass: "member-list"
    }, [_c('h3', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group.members), function(member) {
      return _c('router-link', {
        staticClass: "member-item",
        attrs: {
          "to": ("/Developer/" + (member.stringUrl))
        }
      }, [_c('div', {
        staticClass: "avatar-container"
      }, [_c('avatar', {
        attrs: {
          "profile-data": member,
          "profile-type": "developer",
          "size": "large",
          "show-xp-info": true
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "details"
      }, [_c('h3', [_vm._v(_vm._s(member.alias))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(member.positionTitle))]), _vm._v(" "), _c('span', {
        staticClass: "time"
      }, [_vm._v("From " + _vm._s(_vm._f("formatDateWithoutTime")(member.joinDate)))]), _vm._v(" "), _c('span', {
        staticClass: "time"
      }, [_vm._v("To " + _vm._s(_vm._f("formatDateWithoutTime")(member.endDate)))])])])
    })], 2) : _vm._e()
  })] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.editMembersMode) ? _c('edit-page', {
    attrs: {
      "members": _vm.members,
      "game-id": _vm.gameId
    },
    on: {
      "exitEditMode": function($event) {
        _vm.editMembersMode = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c09f609!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/SubPages/GameMembers.vue
// module id = 886
// module chunks = 2